
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">اضافة شريك</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form [formGroup]="insertForm" (ngSubmit)="Submit()">

                    <div class="row m-0 mb-2">
                        <div class="col-md-6">
                          <label for=""> الاسم
                          </label>
                            <div class="form-group">
                                
                               <input type="text"  class="form-control" formControlName="Title" 
                               [tooltip]="fc.Title.errors?.required ? ' الاسم مطلوب' : null" required
                               [isDisabled]="!((fc.Title.errors?.required && fc.Title.touched))"
                               containerClass="" [class.is-valid]="fc.Title.valid && (fc.Title.touched)"
                               [class.is-invalid]="fc.Title.invalid && (fc.Title.touched)"
                               >
                            </div>
                        </div>
                        <div class="col-md-6">
                          <label for="">نوع الشركة</label>
                          <div class="form-group">
                                <ng-select
                                class="js-example-basic-single p-0"
                                name="CompanyType"
                                placeholder="إختر نوع الشركة"
                                formControlName="CompanyTypeId"
                                required=""
                                [items]="CompanyTypes"
                                bindLabel="title"
                                bindValue="id"
                                >
                                </ng-select>
                            </div>
                        </div>
                 
                                <!-- to insert image  -->
                                <div class="col-6 my-3 " >
                                    <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                                   <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                                    style="display: none" (change)="getLogoUrl($event)" />
                                <button type="button" onclick="document.getElementById('getLogo').click()"
                                    class="btn   d-block"  style="width: 60%;">
                                    ارفاق صورة
                                </button>    
                                            </div>
                                    
                     
                        <div class="col-12 col-md-12">
                            <div *ngIf="update; else elseBlock">
                                <button class="btn  pull-right" type="submit" >
                                  تعديل
                                </button>
                              </div>
                  
                              <ng-template #elseBlock>
                                <button class="btn  pull-right" type="submit">
                                  إضافة
                                </button>
                              </ng-template>
                </div>
                </div>
                    </form>
    </div>
</div>
        </div>
    </div>
</div>